export default {
  reviewCompleteHeader: 'Granska och slutför',
  participants: 'Deltagare',
  enterParticipantInfoText:
    'Vänligen ange de nödvändiga uppgifterna för att fortsätta till kassan.',
  purchaser: 'Köpare',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  email: 'E-post',
  optionalEmail: 'E-post: (valfritt)',
  'phone:': 'Telefon',
  participantFieldPlaceholder: 'Lägg till ny eller välj befintlig deltagare',
  reservationSummary: 'Reservationssammanfattning',
  editParticipantsDetails: 'Redigera deltagaruppgifter',
  participantDetails: 'Uppgifter',
  duplicatePurchaserText: 'Samma som köpare',
  phone: 'Telefon',
  addParticipant: 'Ytterligare {{tierLabel}}',
  participant: 'Deltagare',
  removeParticipant: 'Ta bort',
  experienceCheckoutCompleted: 'Upplevelseköp slutfört',
  experienceCartCheckout: 'Upplevelsevarukorg kassa',
  experienceLimitReached:
    'Tyvärr, denna upplevelse har nått sitt maximala antal deltagare',
  payment: 'Betalning',
  duration: 'Längd',
  discountCode: 'Rabattkod',
  removeCode: 'Ta bort kod',
  invalidCodeValidation: 'Ogiltig kupongkod',
  networkErrorDiscountCode: 'Något gick fel på vår sida',
  onlyOneCouponCodeAllowed: 'Endast en kupongkod är tillåten',
  creditCodeHasAlreadyBeenApplied: 'Kreditkoden har redan tillämpats',
  discount: 'Rabatt',
  promo: 'Kampanj',
  promoCode: 'Kampanjkod',
  apply: 'Tillämpa',
  total: 'Totalt',
  subTotal: 'Delsumma',
  includes: 'Inkluderar',
  and: 'och',
  addHostNotes: 'Lägg till anteckningar för din värd',
  brandAggreementText:
    'Jag godkänner, eller intygar att jag är behörig att på deltagarnas vägnar godkänna, villkoren för',
  termsAggreementValidation: 'Vänligen godkänn villkoren',
  firstNameValidation: 'Förnamn krävs',
  lastNameValidation: 'Efternamn krävs',
  emailValidation: {
    emailRequiredText: 'E-post krävs',
    invalidEmail: 'Ogiltig e-postadress',
    not_specified: 'Felaktig e-postadress',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Ogiltigt telefonnummer',
    not_specified: 'Ogiltigt',
    phoneRequiredText: 'Telefonnummer krävs',
  },
  participantFirstNameValidation: 'Deltagarens förnamn krävs',
  participantLastNameValidation: 'Deltagarens efternamn krävs',
  complete: 'Slutför',
  '404Message': 'Hittades inte',
  waiting: 'Väntar...',
  complimentary: 'Kostnadsfri',
  confirmationHeader: 'Din upplevelse har bokats!',
  confirmationText:
    'Ett bekräftelsemail har skickats till {{email}} med ytterligare information',
  viewAll: 'Visa alla upplevelser',
  paymentMethod: 'Betalningsmetod',
  creditCard: 'Kreditkort',
  roomCharge: 'Rumsdebitering',
  memberCharge: 'Medlemsdebitering',
  roomOrReservationNumber: 'Rumsnummer eller bekräftelsenummer',
  roomNumber: 'Rumsnummer',
  roomNumberLegacy: 'Rumsnummer / Bekräftelsekod',
  memberNumber: 'Medlemsnummer',
  kicc: 'KICC',
  chargeValidation: 'Rumsnummer och efternamn krävs',
  memberNumberValidation: 'Medlemsnummer krävs',
  invalidRoomNumber: 'Rumsnumret är ogiltigt',
  invalidRoomNumberLegacy: 'Rumsnummer eller bekräftelsekod är ogiltig',
  invalidMemberNumber: 'Medlemsnumret är ogiltigt',
  invalidPhoneNumber: 'Telefonnumret är ogiltigt',
  requiredPhoneNumber: 'Telefonnummer krävs',
  guestNameIsRequired: 'Gästnamn krävs',
  roomNumberIsRequired: 'Rumsnummer krävs',
  roomNumberIsRequiredLegacy: 'Rumsnummer eller bekräftelsekod krävs',
  roomOrReservationNumberIsRequired: 'Rumsnummer eller bekräftelsenummer krävs',
  cardNumberIncomplete: 'Kortnummer ofullständigt',
  lastNameValidationError: 'Efternamn krävs',
  isReqd: 'krävs',
  reservationCode: 'Reservations-/bekräftelsenummer',
  nonHotelGuest: 'Ej hotellgäst',
  onPropertyGuest: 'Gäst på hotellet',
  preArrivalGuest: 'Gäst före ankomst',
  cardNumber: 'Kortnummer',
  pmsValidationErrorMessage:
    'Ogiltigt efternamn eller rumsnummer eller bekräftelsenummer',
  pmsDateValidationErrorMessage:
    'Tyvärr! Upplevelsedatumet infaller inte mellan ditt ankomst- och avresedatum.',
  fullName: 'Fullständigt namn',
  checkout: 'Kassa',
  editParticipants: 'Redigera deltagare',
  private: 'Privat',
  browseAllExperieces: 'Bläddra bland alla upplevelser',
  payWithCreditCard: 'Betala med kreditkort',
  payWithRoomCharge: 'Betala med rumsdebitering',
  payWithMemberCharge: 'Betala med medlemsdebitering',
  payWith: 'Betala med',
  bookBulkErrorByCard:
    'Det uppstod ett problem med att bekräfta din bokning. Ditt kort debiterades inte.',
  bookBulkErrorByRoomCharge: 'Ogiltigt efternamn och rumsnummer.',
  bookBulkErrorByMemberCharge: 'Ogiltigt efternamn och medlemsnummer.',
  reviewCancellation: 'Granska avbokning',
  selectAReservationToCancel: 'Välj en reservation att avboka',
  confirmCancellation: 'Bekräfta avbokning',
  cancellable: 'Kan avbokas',
  cancelled: 'Avbokad',
  deadlinePassed: 'Tidsgräns passerad',
  noCancellations: 'Inga avbokningar',
  reviewReschedule: 'Din reservation',
  selectAReservationToReschedule: 'Välj en reservation att omboka',
  confirmReservation: 'Bekräfta reservation',
  confirm: 'Bekräfta',
  selectADateAndTime: 'Välj datum och tid',
  noOtherSessionsAvailableForThisExperience:
    'Det finns inga andra tillgängliga sessioner för denna upplevelse.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Denna reservation kan inte längre ombokas. Vänligen maila {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'Denna reservation kan inte ombokas',
  noTimesAvailable: 'Inga tillgängliga tider',
  noBookingsAvailable: 'Inga bokningar tillgängliga',
  youPaid: 'Du betalade',
  refund: 'Återbetalning',
  yourRefund: 'Din återbetalning',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Din återbetalning kommer att behandlas till den ursprungliga betalningen.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Denna reservation kan inte längre avbokas. Vänligen maila {{brandEmail}}',
  reservationCancelled: 'Reservation avbokad',
  thisReservationCannotBeCancelled: 'Denna reservation kan inte avbokas',
  thisReservationHasAlreadyBeenCancelled:
    'Denna reservation har redan avbokats',
  theHotel: 'hotellet',
  cancelling: 'Avbokar',
  somethingWentWrong: 'Något gick fel',
  previouslyRefunded: 'Tidigare återbetald',
  remainingBalance: 'Återstående saldo',
  notEnoughPoints: 'Inte tillräckligt med poäng',
  notEnoughPointsDescription:
    'Du har inte tillräckligt med World of Hyatt-poäng för att slutföra detta köp.',
  currentPointsBalance: 'Aktuellt poängsaldo: {{count, number}}',
  points: 'poäng',
  pointsWithCount_one: '{{count, number}} poäng',
  pointsWithCount_other: '{{count, number}} poäng',
  payWithHyattPoints: 'Betala med Hyatt-poäng',
  pleaseSignIn: 'Vänligen logga in',
  worldOfHyattPoints: 'World of Hyatt-poäng',
  bookBulkErrorByNotEnoughSeats:
    'Inte tillräckligt med platser tillgängliga för sessionen. Vänligen prova en annan session istället.',
  phoneNumber: 'Telefonnummer',
  requestToBookConfirmationText:
    'Ett bekräftelsemail har skickats till {{email}}',
  reservationRescheduled: 'Reservation ombokad',
  yourReservationWasRescheduledTo: 'Din reservation har ombokats till',
  viewExperiences: 'Visa upplevelser',
  joinBook: 'Gå med & boka',
  signInBook: 'Logga in & boka',
  signAndJoin: 'Logga in eller gå med för att boka',
  signAndJoinDescription:
    'World of Hyatt FIND-upplevelser är exklusiva för World of Hyatt-medlemmar. Logga in eller gå med för att boka och tjäna poäng. Föredrar du att inte gå med? Du kan fortfarande boka icke-exklusiva upplevelser genom att ta bort World of Hyatt-upplevelsen från din varukorg.',
  promoOrFind: 'Kampanj- eller Find-kreditkod',
  hyattTermsAndConditions: 'Villkor',
  hyattTermsAndConditionsAgreement:
    'Genom att bekräfta denna bokning accepterar jag avbokningspolicyn. Jag har även läst och bekräftar användningen av min personliga information i enlighet med',
  hyattTermsAndConditionsLink: 'Hyatts sekretesspolicyer',
  hyattWaiverText:
    'Genom att köpa denna upplevelse godkänner, förstår och bekräftar jag, både för min egen räkning och för alla individer som deltar i upplevelsen köpt av mig (om tillämpligt), följande',
  hyattWaiverLink: 'allmän ansvarsfriskrivning',
  priceDisclaimer: 'Inkluderar avgifter före skatt',
  curatedRecommendations: 'Utvalda rekommendationer',
  moreExperiencesYouMightLike: 'Fler upplevelser du kanske gillar',
  similarExperiencesAvailableToBookDirectly:
    'Liknande upplevelser tillgängliga för direktbokning',
  experiencesAvailableAroundYourBookingDate:
    'Upplevelser tillgängliga kring ditt bokningsdatum',
  confirmationEmailSent:
    'Vi har skickat din bekräftelse till {{email}} med fler detaljer.',
  youreBooked: 'Du är bokad',
  purchaserInformation: 'Köparinformation',
  requiredFieldIndicator: '* anger ett obligatoriskt fält',
  resourceSelectionTitle: 'Välj dina alternativ',
  resourceSelectionDescription:
    'Välj ett alternativ för varje artikel i din bokning.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Välj {{attributeName}}',
  resourceValueSoldOut: '{{label}} (slutsåld)',
  resourceValueUnavailableWith: '{{label}} (inte tillgänglig med {{picks}})',
  resourceOptionsUnavailable:
    'Vi kunde inte läsa in alternativen för den här tiden. Försök igen.',
  resourceOptionsRetry: 'Försök igen',
  changeResourceSelections: 'Ändra dina val',
};
